import script from "./FreemiumDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./FreemiumDashboard.vue?vue&type=script&setup=true&lang=js"

import "./FreemiumDashboard.vue?vue&type=style&index=0&id=3058b1c2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3058b1c2"]])

export default __exports__